
// Our Clients PUBLICATION HOUSES 1-34
import image1 from './Picture1.png'
import image2 from './Picture2.png'
import image3 from './Picture3.png'
import image4 from './Picture4.png'
import image5 from './Picture5.png'
import image6 from './Picture6.png'
import image7 from './Picture7.png'
import image8 from './Picture8.png'
import image9 from './Picture9.png'
import image10 from './Picture10.png'
import image11 from './Picture11.png'
import image12 from './Picture12.png'
import image13 from './Picture13.png'
import image14 from './Picture14.png'
import image15 from './Picture15.png'
import image16 from './Picture16.png'
import image17 from './Picture17.png'
import image18 from './Picture18.png'
import image19 from './Picture19.png'
import image20 from './Picture20.png'
import image21 from './Picture21.png'
import image22 from './Picture22.png'
import image23 from './Picture23.png'
import image24 from './Picture24.png'
import image25 from './Picture25.png'
import image26 from './Picture26.png'
import image27 from './Picture27.png'
import image28 from './Picture28.png'
import image29 from './Picture29.png'
import image30 from './Picture30.png'
import image31 from './Picture31.png'
import image32 from './Picture32.png'
import image33 from './Picture33.png'
import image34 from './Picture34.png'

// Govt. Department & Ministries 35-51
import image35 from './Picture35.png'
import image36 from './Picture36.png'
import image37 from './Picture37.png'
import image38 from './Picture38.png'
import image39 from './Picture39.png'
import image40 from './Picture40.png'
import image41 from './Picture41.png'
import image42 from './Picture42.png'
import image43 from './Picture43.png'
import image44 from './Picture44.png'
import image45 from './Picture45.png'
import image46 from './Picture46.png'
import image47 from './Picture47.png'
import image48 from './Picture48.png'
import image49 from './Picture49.png'
import image50 from './Picture50.png'
import image51 from './Picture51.png'

// Our Clients CORPORATE HOUSE 52-81
import image52 from './Picture52.png'
import image53 from './Picture53.png'
import image54 from './Picture54.png'
import image55 from './Picture55.png'
import image56 from './Picture56.png'
import image57 from './Picture57.png'
import image58 from './Picture58.png'
import image59 from './Picture59.png'
import image60 from './Picture60.png'
import image61 from './Picture61.png'
import image62 from './Picture62.png'
import image63 from './Picture63.png'
import image64 from './Picture64.png'
import image65 from './Picture65.png'
import image66 from './Picture66.png'
import image67 from './Picture67.png'
import image68 from './Picture68.png'
import image69 from './Picture69.png'
import image70 from './Picture70.png'
import image71 from './Picture71.png'
import image72 from './Picture72.png'
import image73 from './Picture73.png'
import image74 from './Picture74.png'
import image75 from './Picture75.png'
import image76 from './Picture76.png'
import image77 from './Picture77.png'
import image78 from './Picture78.png'
import image79 from './Picture79.png'
import image80 from './Picture80.png'
import image81 from './Picture81.png'

const images = [{
    "title": "Our Clients PUBLICATION HOUSES",
    imagesArray: [
        image1,
        image2,
        image3,
        image4,
        image5,
        image6,
        image7,
        image8,
        image9,
        image10,
        image11,
        image12,
        image13,
        image14,
        image15,
        image16,
        image17,
        image18,
        image19,
        image20,
        image21,
        image22,
        image23,
        image24,
        image25,
        image26,
        image27,
        image28,
        image29,
        image30,
        image31,
        image32,
        image33,
        image34,
    ]
},
{
    "title": "Govt. Department & Ministries",
    imagesArray: [
        image35,
        image36,
        image37,
        image38,
        image39,
        image40,
        image41,
        image42,
        image43,
        image44,
        image45,
        image46,
        image47,
        image48,
        image49,
        image50,
        image51,
    ]
},
{
    "title": "Our Clients CORPORATE HOUSE",
    imagesArray: [
        image52 ,
        image53 ,
        image54 ,
        image55 ,
        image56 ,
        image57 ,
        image58 ,
        image59 ,
        image60 ,
        image61 ,
        image62 ,
        image63 ,
        image64 ,
        image65 ,
        image66 ,
        image67 ,
        image68 ,
        image69 ,
        image70 ,
        image71 ,
        image72 ,
        image73 ,
        image74 ,
        image75 ,
        image76 ,
        image77 ,
        image78 ,
        image79 ,
        image80 ,
        image81 ,
        
    ]
},]

export default images